import React from "react";
import { Carousel } from "antd";
import { theme } from "../../../utils/theme";

const IMAGES = [
  "https://img.freepik.com/free-photo/portrait-man-working-laptop_23-2148898741.jpg",
  "https://media.istockphoto.com/id/1388913352/photo/lovely-business-man-attending-a-meeting-online-writing-stuff-down.jpg?s=612x612&w=0&k=20&c=xkrlDeFMcPOoelyiWd_FwuFOuGi23Fd-t18CxR15okE=",
  "https://media.istockphoto.com/id/1354077790/photo/man-working-at-home.jpg?s=612x612&w=0&k=20&c=ePzpG0JgiHd4R85JyoyxIndl4vYQP6avw9nNJ6Zgg8w=",
  "https://media.istockphoto.com/id/1186079153/photo/hell-stay-until-he-has-it-all-figured-out.jpg?s=612x612&w=0&k=20&c=OK2bPjppdTpV9JPMmAua9gNMQnY_PObdkzmKWFj8Pmg=",
];

const SlideShow = () => {
  return (
    <div
      style={{
        width: "100%",
        backgroundColor: theme.backgroundGrayColor,
        padding: 20,
      }}>
      <div
        style={{
          maxWidth: "1200px",
          margin: "auto",
          marginTop: 20,
          marginBottom: 20,
        }}>
        <Carousel arrows adaptiveHeight autoplay>
          {IMAGES.map((image, index) => (
            <div key={index}>
              <img
                src={image}
                alt={`slide-${index}`}
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                }}
              />
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default SlideShow;
